var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTopAgents = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#202124",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3,
  d: "M1.539 15.706 5.52 4.742a.592.592 0 0 1 .978-.214l6.973 6.973a.593.593 0 0 1-.214.978L2.294 16.46a.584.584 0 0 1-.755-.755M11.17 5.646s0-1.777 1.777-1.777 1.776-1.777 1.776-1.777M6.313 15.003l-3.316-3.316M9.393 1.5v1.777M14.723 8.607l1.185 1.184M14.723 6.238l1.777-.592M4.418 7.778l5.804 5.804"
})));
export default SvgTopAgents;